import React, { PropTypes } from "react";
import { FormattedHTMLMessage, FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Field, formValueSelector, reduxForm } from "redux-form";

import * as dataActions from "../../../../../utils/data/dataActions";
import { CLIENT_V2, MAJOR_CODE_RECUPERATION } from "../../../../../utils/data/models";
import { RECOVERY_FORM_MESSAGE_VALIDATION_RULES } from "./RecoveryFormMessageValidationRules";
import userHasAccess from "../../../../../utils/userHasAccess";
import { ALL_ROLES_WITHOUT_AGENT } from "../../../../../utils/Roles";

import {
  EndUserFormMessageConfiguration,
  StyledCheckboxInput,
} from "../../../../common/form";

class BasicMemberIdentifierConfigurationFields extends React.Component {
  constructor(props) {
    super(props);

    this.updateConfiguration = this.updateConfiguration.bind(this);
    this.updateMessageConfiguration = this.updateMessageConfiguration.bind(
      this
    );
  }

  saveMessageForm(formValues) {
    const { dataActions, clientId } = this.props;
    formValues["isMessageUpdate"] = true;
    const dataToUpdate = { clientId, ...formValues };

    const model = { path: MAJOR_CODE_RECUPERATION.path.replace("{}", clientId) };
    dataActions.simplePost({ model, data: dataToUpdate }).then(() => {
      dataActions.getDataItem(CLIENT_V2, clientId);
    });
  }

  updateConfiguration(event) {
    const { dataActions, clientId } = this.props;
    const model = { path: MAJOR_CODE_RECUPERATION.path.replace("{}", clientId) };

    if (event.target) {
      const field = event.target.name;
      const checked = event.target.checked;

      const values = { clientId, [field]: checked };
      dataActions.simplePost({ model, data: values }).then(() => {
        this.props.dataActions.getDataItem(CLIENT_V2, clientId);
      });
    }
  }

  updateMessageConfiguration(formValues) {
    this.saveMessageForm(formValues);
  }

  render() {
    const {
      clientDesignator,
      handleSubmit,
      hasMemberIdentifierRecoveryForm,
      languageCode,
    } = this.props;
    const { localizations } = this.props.initialValues;
    let formLabel = "";
    const isRoleValid = userHasAccess(ALL_ROLES_WITHOUT_AGENT, true);
    if (hasMemberIdentifierRecoveryForm) {
      let url = "";
      switch (languageCode) {
        case "fr-CA":
          url = "/recuperation-codemajor/";
          break;
        case "en-CA":
          url = "/majorcode-recovery/";
          break;
      }
      url += clientDesignator;
      formLabel = (
        <span>
          <FormattedHTMLMessage id="memberIdentifierConfiguration.form.createRecoveryForm" />
          &nbsp;&nbsp;
          <a
            className="highlight"
            target="_blank"
            href={url}
            title={`${window.location.hostname}${url}`}
          >
            <span className="icon icon-new-tab" />
          </a>
        </span>
      );
    } else {
      formLabel = (
        <FormattedHTMLMessage id="memberIdentifierConfiguration.form.createRecoveryForm" />
      );
    }

    return (
      <form
        onSubmit={handleSubmit}
        className="member-identifier-configuration configuration-form"
      >
        <h3>
          <FormattedMessage id="clients.client.pages.memberIdentifier" />
        </h3>
        <Field
          id="hasMemberIdentifierRecoveryForm"
          name="hasMemberIdentifierRecoveryForm"
          component={StyledCheckboxInput}
          groupClassName="inverted-label"
          type="checkbox"
          checkbox={{ value: true }}
          disabled={!isRoleValid}
          props={{ onChange: this.updateConfiguration }}
          label={formLabel}
        />
        {hasMemberIdentifierRecoveryForm && (
          <div className="indented">
            <Field
              id="mustUseInstitutionEmailForRecovery"
              name="mustUseInstitutionEmailForRecovery"
              component={StyledCheckboxInput}
              type="checkbox"
              disabled={!isRoleValid}
              checkbox={{ value: true }}
              props={{ onChange: this.updateConfiguration }}
              label={
                <FormattedHTMLMessage id="memberIdentifierConfiguration.form.mustUseInstitutionEmailForRecovery" />
              }
            />
            <hr />
            <h4>
              <FormattedMessage id="memberIdentifierConfiguration.form.recoveryFormMessage" />
            </h4>
            <EndUserFormMessageConfiguration
              fieldType="textarea"
              form="recoveryFormMessageConfiguration"
              initialValues={{ localizations }}
              localizedFieldName="recoveryMemberIdentifierFormMessage"
              onSubmit={this.updateMessageConfiguration}
              validationRules={RECOVERY_FORM_MESSAGE_VALIDATION_RULES}
            />
          </div>
        )}
      </form>
    );
  }
}

BasicMemberIdentifierConfigurationFields.propTypes = {
  clientDesignator: PropTypes.string,
  clientId: PropTypes.number,
  dataActions: PropTypes.object,
  handleSubmit: PropTypes.func,
  hasMemberIdentifierRecoveryForm: PropTypes.bool,
  initialValues: PropTypes.object,
  languageCode: PropTypes.string,
};

function initializeClientLocalizations(languages, localizations) {
  const result = { ...(localizations || {}) };
  languages
    .sort((a, b) => a.languageCode.localeCompare(b.languageCode))
    .map((language) => {
      const languageCode = language.languageCode;
      result[languageCode] = result[languageCode] || {
        memberIdentifierRecoveryFormMessage: "",
      };
    });
  return result;
}

function mapStateToProps(state, ownProps) {
  const selector = formValueSelector("memberIdentifierConfiguration");
  const activeClient = state.data.clients.active;
  const languageCode = state.auth.user.languageCode;
  const {
    clientId,
    designator,
    hasMemberIdentifierRecoveryForm,
    mustUseInstitutionEmailForRecovery,
  } = activeClient;

  const localizations = initializeClientLocalizations(
    ownProps.languages,
    activeClient.localizations
  );

  const memberIdentifierConfiguration = {
    hasMemberIdentifierRecoveryForm,
    localizations,
    mustUseInstitutionEmailForRecovery,
  };

  return {
    clientDesignator: designator,
    clientId,
    hasMemberIdentifierRecoveryForm: selector(
      state,
      "hasMemberIdentifierRecoveryForm"
    ),
    languageCode,
    initialValues: memberIdentifierConfiguration,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dataActions: bindActionCreators(dataActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  withRef: true,
})(
  reduxForm({
    form: "memberIdentifierConfiguration",
  })(BasicMemberIdentifierConfigurationFields)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/member-identifier-configuration/BasicMemberIdentifierConfigurationFields.js